import { render, staticRenderFns } from "./ProductEditIntrastatData.vue?vue&type=template&id=48aae0ee&scoped=true"
import script from "./ProductEditIntrastatData.vue?vue&type=script&lang=ts"
export * from "./ProductEditIntrastatData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aae0ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48aae0ee')) {
      api.createRecord('48aae0ee', component.options)
    } else {
      api.reload('48aae0ee', component.options)
    }
    module.hot.accept("./ProductEditIntrastatData.vue?vue&type=template&id=48aae0ee&scoped=true", function () {
      api.rerender('48aae0ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditIntrastatData.vue"
export default component.exports